import React from 'react';
import { Menu, MenuItem, MenuButton, useAuthenticator } from '@aws-amplify/ui-react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'aws-amplify/auth';
import InitialsAvatar from '../common/InitialsAvatar';
import { deriveFriendlyName } from '../../shared/userDisplay';

async function handleSignOut() {
  try {
    await signOut();
  } catch (error) {
    console.warn('error signing out: ', error);
  } finally {
    try {
      for (let i = localStorage.length - 1; i >= 0; i--) {
        const key = localStorage.key(i);
        if (key?.startsWith('geisti.idempotency.')) localStorage.removeItem(key);
      }
      for (let i = sessionStorage.length - 1; i >= 0; i--) {
        const key = sessionStorage.key(i);
        if (key?.startsWith('geisti.landed.')) sessionStorage.removeItem(key);
      }
    } catch {
      // sandboxed iframe / privacy mode — silent
    }
  }
}

const SidebarUserMenu = () => {
  const navigate = useNavigate();
  const { user } = useAuthenticator(ctx => [ctx.user]);
  const email = (user?.signInDetails as { loginId?: string } | undefined)?.loginId;
  const name = deriveFriendlyName(email, user?.username);

  return (
    <Menu
      menuAlign="start"
      trigger={
        <MenuButton
          variation="menu"
          className="sidebar-user-menu__trigger"
          aria-label={`Account menu for ${name ?? email ?? 'signed-in user'}`}
        >
          <InitialsAvatar name={name ?? undefined} email={email ?? undefined} size={32} />
        </MenuButton>
      }
    >
      <MenuItem onClick={() => navigate('/profile')}>Profile</MenuItem>
      <MenuItem onClick={() => handleSignOut()}>Sign out</MenuItem>
    </Menu>
  );
};

export default SidebarUserMenu;
